<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">时间:</div>
                <el-date-picker
                    v-model="conditionData.date"
                    type="date"
                    size="small"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">医保类型:</div>
                <el-input v-model="conditionData.CPlyNo" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">药品类型:</div>
                <el-select v-model="conditionData.DcTaskActions" multiple size="small" placeholder="请选择" class="input">
                    <el-option
                    v-for="item in list"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">药品名称:</div>
                <el-input v-model="conditionData.CPlyNo" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ypmc"
                label="药品名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="tym"
                label="通用名"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="jx"
                label="剂型"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="yblb"
                label="医保类别"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ybbh"
                label="医保编号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ypfl"
                label="药品分类"
                align="center"
                width="350px"
                >
                </el-table-column>
                <el-table-column
                prop="qy"
                label="区域"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="zbqk"
                label="增补情况"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="ybbb"
                label="医保版本"
                align="center"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="zxsj"
                label="执行时间"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="zxzt"
                label="执行状态"
                align="center"
                >
                </el-table-column>

                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deletePetShop(scope.row)">删除</el-button>
                </template>
                </el-table-column> -->
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        
       <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'person',
    components:{
        ElImageViewer,
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                petShop:'',
                page:1,
                pageSize:10,
            },
            addData:{},
            updateData:{
                petShop:'',
                contacts:'',
                phone:'',
                address:'',
                province:'',
                city:'',
                area:'',
                addressCode:'',
                projectPrices:[{
                    name: '',
                    price: '',
                }],
            },
            tableData:[

                {ypmc:'葡萄糖酸氯己定含漱液',tym:'葡萄糖酸',jx:'溶液剂',yblb:'乙类',ybbh:'4',ypfl:'消化道和代谢方面的药物>口腔科制剂(XA>XA01)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'枸橼酸铋钾颗粒',tym:'枸橼酸铋钾',jx:'颗粒剂',yblb:'甲类',ybbh:'★（8）',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>抗酸药(XA>XA02>XA02A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'法莫替丁胶囊',tym:'法莫替丁',jx:'胶囊剂',yblb:'甲类',ybbh:'13',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>H2-受体拮抗剂(XA>XA02>XA02B>XA02BA)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'盐酸雷尼替丁胶囊',tym:'雷尼替丁',jx:'胶囊剂',yblb:'甲类',ybbh:'14',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>H2-受体拮抗剂(XA>XA02>XA02B>XA02BA)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'奥美拉唑肠溶片',tym:'奥美拉唑',jx:'片剂',yblb:'甲类',ybbh:'15',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>质子泵抑制剂(XA>XA02>XA02B>XA02BC)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'艾司奥美拉唑镁肠溶片',tym:'艾司奥美拉唑',jx:'片剂',yblb:'乙类',ybbh:'16',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>质子泵抑制剂(XA>XA02>XA02B>XA02BC)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'注射用埃索美拉唑钠',tym:'埃索美拉唑',jx:'注射剂',yblb:'乙类',ybbh:'★（16）',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>质子泵抑制剂(XA>XA02>XA02B>XA02BC)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'注射用艾司奥美拉唑钠',tym:'艾司奥美拉唑',jx:'注射剂',yblb:'乙类',ybbh:'★（16）',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>质子泵抑制剂(XA>XA02>XA02B>XA02BC)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'兰索拉唑肠溶胶囊',tym:'兰索拉唑',jx:'胶囊剂',yblb:'乙类',ybbh:'18',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>质子泵抑制剂(XA>XA02>XA02B>XA02BC)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'吉法酯片',tym:'吉法酯',jx:'片剂',yblb:'乙类',ybbh:'21',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>其他治疗消化性溃疡病和胃食道反流病的药物(XA>XA02>XA02B>XA02BX)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'硫糖铝片',tym:'硫糖铝',jx:'片剂',yblb:'乙类',ybbh:'22',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>其他治疗消化性溃疡病和胃食道反流病的药物(XA>XA02>XA02B>XA02BX)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'硫糖铝混悬凝胶',tym:'硫糖铝',jx:'凝胶剂',yblb:'乙类',ybbh:'★（22）',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>其他治疗消化性溃疡病和胃食道反流病的药物(XA>XA02>XA02B>XA02BX)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'硫糖铝口服混悬液',tym:'硫糖铝',jx:'溶液剂',yblb:'乙类',ybbh:'★（22）',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>其他治疗消化性溃疡病和胃食道反流病的药物(XA>XA02>XA02B>XA02BX)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'瑞巴派特胶囊',tym:'瑞巴派特',jx:'胶囊剂',yblb:'乙类',ybbh:'23',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>其他治疗消化性溃疡病和胃食道反流病的药物(XA>XA02>XA02B>XA02BX)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'瑞巴派特片',tym:'瑞巴派特',jx:'片剂',yblb:'乙类',ybbh:'23',ypfl:'消化道和代谢方面的药物>治疗胃酸相关类疾病的药物>治疗消化性溃疡病和胃食道反流病的药物>其他治疗消化性溃疡病和胃食道反流病的药物(XA>XA02>XA02B>XA02BX)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'二甲硅油片',tym:'二甲硅油',jx:'片剂',yblb:'乙类',ybbh:'26',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>治疗功能性肠道疾病的药物(XA>XA03>XA03A>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'间苯三酚注射液',tym:'间苯三酚',jx:'注射剂',yblb:'乙类',ybbh:'28',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>治疗功能性肠道疾病的药物(XA>XA03>XA03A>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'马来酸曲美布汀分散片',tym:'曲美布汀',jx:'片剂',yblb:'乙类',ybbh:'29',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>治疗功能性肠道疾病的药物(XA>XA03>XA03A>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'硫酸阿托品片',tym:'阿托品',jx:'片剂',yblb:'甲类',ybbh:'32',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>单方颠茄及其衍生物(XA>XA03>XA03B>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'丁溴东莨菪碱胶囊',tym:'丁溴东莨菪碱',jx:'胶囊剂',yblb:'乙类',ybbh:'36',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>单方颠茄及其衍生物(XA>XA03>XA03B>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'注射用丁溴东莨菪碱',tym:'丁溴东莨菪碱',jx:'注射剂',yblb:'乙类',ybbh:'★（36）',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>单方颠茄及其衍生物(XA>XA03>XA03B>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'消旋山莨菪碱片',tym:'消旋山莨菪碱',jx:'片剂',yblb:'乙类',ybbh:'★（34）',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>单方颠茄及其衍生物(XA>XA03>XA03B>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'多潘立酮胶囊',tym:'多潘立酮',jx:'胶囊剂',yblb:'甲类',ybbh:'37',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>胃肠动力药(XA>XA03>XA03F>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'盐酸甲氧氯普胺注射液',tym:'甲氧氯普胺',jx:'注射剂',yblb:'甲类',ybbh:'★（38）',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>胃肠动力药(XA>XA03>XA03F>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'枸橼酸莫沙必利片',tym:'莫沙必利',jx:'片剂',yblb:'甲类',ybbh:'39',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>胃肠动力药(XA>XA03>XA03F>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'多潘立酮混悬液',tym:'多潘立酮',jx:'溶液剂',yblb:'乙类',ybbh:'★（37）',ypfl:'消化道和代谢方面的药物>治疗功能性胃肠道疾病的药物>胃肠动力药(XA>XA03>XA03F>)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'盐酸格拉司琼片',tym:'格拉司琼',jx:'片剂',yblb:'乙类',ybbh:'43',ypfl:'消化道和代谢方面的药物>止吐药和止恶心药(XA>XA04)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'盐酸格拉司琼注射液',tym:'格拉司琼',jx:'注射剂',yblb:'乙类',ybbh:'★（43）',ypfl:'消化道和代谢方面的药物>止吐药和止恶心药(XA>XA04)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'甲磺酸托烷司琼片',tym:'托烷司琼',jx:'片剂',yblb:'乙类',ybbh:'45',ypfl:'消化道和代谢方面的药物>止吐药和止恶心药(XA>XA04)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'熊去氧胆酸胶囊',tym:'熊去氧胆酸',jx:'胶囊剂',yblb:'甲类',ybbh:'46',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>胆治疗药(XA>XA05>XA05A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'熊去氧胆酸片',tym:'熊去氧胆酸',jx:'片剂',yblb:'甲类',ybbh:'46',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>胆治疗药(XA>XA05>XA05A)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'联苯双酯滴丸',tym:'联苯双酯',jx:'丸剂',yblb:'甲类',ybbh:'★（47）',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'多烯磷脂酰胆碱胶囊',tym:'多烯磷脂酰胆碱',jx:'胶囊剂',yblb:'乙类',ybbh:'49',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'注射用复方甘草酸苷',tym:'复方甘草酸苷',jx:'注射剂',yblb:'乙类',ybbh:'★（50）',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'甘草酸二铵肠溶胶囊',tym:'甘草酸二铵',jx:'胶囊剂',yblb:'乙类',ybbh:'51',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'注射用甘草酸二铵',tym:'甘草酸二铵',jx:'注射剂',yblb:'乙类',ybbh:'★（51）',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'硫普罗宁肠溶胶囊',tym:'硫普罗宁',jx:'胶囊剂',yblb:'乙类',ybbh:'54',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'葡醛内酯胶囊',tym:'葡醛内酯',jx:'胶囊剂',yblb:'乙类',ybbh:'56',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'双环醇片',tym:'双环醇',jx:'片剂',yblb:'乙类',ybbh:'57',ypfl:'消化道和代谢方面的药物>胆和肝治疗药>肝脏治疗药，抗脂肪肝药(XA>XA05>XA05B)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},
                {ypmc:'聚乙二醇4000散',tym:'聚乙二醇',jx:'散剂、颗粒剂',yblb:'甲类',ybbh:'62',ypfl:'消化道和代谢方面的药物>治疗便秘药物(XA>XA06)',qy:'国家医保',zbqk:'国家医保品种',ybbb:'国家医保(2021年版）',zxsj:'2022/1/1',zxzt:'执行中'},







            ],

            addressList:[],
            options:regionData,
            picList1:[],
            picList2:[],
            picList3:[],
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            list:[
                '化学药','生物制品','中成药','中药饮片'
            ],
        }
    },
    created(){
        

    },
    mounted(){
        // this.loadingData();
    },
    methods:{

        async addImg1(file){
            let res = await api.uploadOther(file.file);
            this.picList1.push(res);
        },
        async addImg2(file){
            let res = await api.uploadOther(file.file);
            this.picList2.push(res);
        },
        async addImg3(file){
            let res = await api.uploadOther(file.file);
            this.picList3.push(res);

        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        previewImg(index,piclist){
            this.imgIndex = index
            this.showBigImgList = piclist;
            this.showBigImg = true;
        },
        clearImg(index,type){
            if(type==1){
                this.picList1.splice(index,1)
            }else if(type==2){
                this.picList2.splice(index,1)
            }else if(type==3){
                this.picList3.splice(index,1)
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.collectPetQueryPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            // this.loadingData();
        },
        reset(){
            this.conditionData = {
                // name:'',
                page:1,
                pageSize:10,
            };
            // this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.title = '新增';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        async addRole(){
            let res  = await api.CreateRole(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData = {};
                this.isAddDialog = false;
            }

        },
        async deletePetShop(row){

            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deletePetShopFun(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });


            
        },
        async deletePetShopFun(id){
            let res  = await api.collectPetDelete(id);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
        },
        async updateshop(){
            for(let index in this.updateData.projectPrices){
                this.updateData.projectPrices[index].price = parseFloat(this.updateData.projectPrices[index].price?this.updateData.projectPrices[index].price:0)
            }
            this.updateData.shopLog = JSON.stringify(this.picList1);
            this.updateData.jyzz = JSON.stringify(this.picList2);
            this.updateData.jyxm = JSON.stringify(this.picList3);
            let res  = await api.collectPetUpdate(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }

        },
        isUpdateDialogShow(row){
            this.title = '编辑';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
            this.addressList = this.updateData.addressCode.split(',');
            this.picList1 = JSON.parse(this.updateData.shopLog?this.updateData.shopLog:'[]')
            this.picList2 = JSON.parse(this.updateData.jyzz?this.updateData.jyzz:'[]')
            this.picList3 = JSON.parse(this.updateData.jyxm?this.updateData.jyxm:'[]')
        },
        deleteXM(index){
            this.updateData.projectPrices.splice(index);
        },
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.province = CodeToText[codeArray[0]]
                this.updateData.addressCode = codeArray[0]
            }
            if(codeArray[1]){
                this.updateData.city = CodeToText[codeArray[1]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.updateData.area = CodeToText[codeArray[2]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[2]
            }
        },
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 11,
                "Condition":{
                    "petShop":this.conditionData.petShop,
                    "pageSize":10000,
                }
                
            },'宠物店资料收集');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 80px;
                margin-left: 15px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                width: 215px;
            }
            .label-pic{
                width: 600px;
                display: flex;
                align-items: center;
                span{
                    color: red;
                    font-size: 20px;
                    margin: 0 4px;
                    margin-top: 2px;
                }
            }
            .pics{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 10px;
                .pics-item{
                    width: 120px;
                    height: 120px;
                    position: relative;
                    margin-right: 10px;
                    margin-left: 10px;
                    .pics-item-img{
                        width: 120px;
                        height: 120px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
                .chooseimg{
                    margin-right: 10px;
                    margin-left: 10px;
                }
                img{
                    width: 120px;
                    height: 120px;
                    margin: 0;
                    margin-bottom: 20px;
                }
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
